import { call, all, takeEvery, put } from 'redux-saga/effects';

import {
  loadingTransactionsSummary,
  loadingBalanceAdmin,
  changeTransactionsSummary,
  changeBalanceAdmin,
  TransactionActionTypes,
} from 'store/reducers/summary.reducer';
import { getSummaryTransactionsAdmin, getBalanceAdmin } from 'utils/web-api';
import Notification from 'utils/notifications';

function* transactionsSummaryAdmin({payload}) {
  try {
    yield put(loadingTransactionsSummary(true))
    const response = yield call(getSummaryTransactionsAdmin, payload);
    yield put(changeTransactionsSummary(response));
  } catch (error) {
   Notification('error', 'Erro ao carregar as transações por método de pagamento.');
  } finally {
    yield put(loadingTransactionsSummary(false));
  }
}

function* balanceAdmin() {
  try {
    yield put(loadingBalanceAdmin(true));
    const response = yield call(getBalanceAdmin);

    const normalized = {
      available: response?.total_available ?? 0,
      on_hold: response?.total_on_hold ?? 0,
      total: response?.total ?? 0,
    };

    yield put(changeBalanceAdmin(normalized));
  } catch (error) {
    Notification(error);
  } finally {
    yield put(loadingBalanceAdmin(false));
  }
}

export default function* MySaga() {
  yield all([
    takeEvery(TransactionActionTypes.ASYNC_TRANSACTIONS_SUMMARY_ADMIN, transactionsSummaryAdmin),
    takeEvery(TransactionActionTypes.ASYNC_BALANCE_ADMIN, balanceAdmin),
  ]);
}
